module.exports = __webpack_public_path__ + "img/taqueria.d0a9f0bb.jpg";